export default "__VITE_ASSET__463e50c2__"